// extracted by css-extract-rspack-plugin
export default {"cls1":"SearchOnboardingOverhaul-cls1_W_n","cls2":"SearchOnboardingOverhaul-cls2_6ez SearchOnboardingOverhaul-cls1_W_n"};